let pendingMagicToken = null;
let pendingReturnPath = null;
let pendingEmailChangeToken = null;

const normalizeReturnPath = (value) =>
  value === "/power-up" || value === "/agent/dashboard" || value === "/agent/email"
    ? value
    : "/agent/dashboard";

const decodePathToken = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (_error) {
    return value;
  }
};

// Capture credentials and clean the address bar before telemetry is initialized.
// Credentials remain only in module memory until the auth flow reads them.
export const captureAgentLoginCredentials = () => {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  const pathMatch = url.pathname.match(/^\/agent\/verify\/([^/]+)$/);
  const isLoginVerification = url.pathname === "/agent/verify" || Boolean(pathMatch);
  pendingMagicToken = isLoginVerification
    ? url.searchParams.get("token") || (pathMatch ? decodePathToken(pathMatch[1]) : null)
    : null;
  pendingEmailChangeToken = url.pathname === "/agent/email/confirm"
    ? url.searchParams.get("token")
    : null;
  if (url.pathname === "/agent/verify" || pathMatch || url.pathname === "/agent/login") {
    pendingReturnPath = normalizeReturnPath(url.searchParams.get("next"));
  }
  const retiredPermanentCredential = ["permanentToken", "auth", "permanent"].some(
    (parameter) => url.searchParams.has(parameter)
  );

  let nextPath = retiredPermanentCredential
    ? "/agent/login"
    : pathMatch
      ? "/agent/verify"
      : url.pathname;
  let changed = Boolean(pathMatch);
  for (const parameter of ["token", "next", "permanentToken", "auth", "permanent"]) {
    if (url.searchParams.has(parameter)) {
      url.searchParams.delete(parameter);
      changed = true;
    }
  }

  if (changed) {
    const search = url.searchParams.toString();
    window.history.replaceState(
      {},
      "",
      `${nextPath}${search ? `?${search}` : ""}${url.hash}`
    );
  }
};

export const getCapturedMagicToken = () => pendingMagicToken;

export const getCapturedEmailChangeToken = () => pendingEmailChangeToken;

export const clearCapturedEmailChangeToken = () => {
  pendingEmailChangeToken = null;
};

export const getCapturedAgentReturnPath = () =>
  normalizeReturnPath(pendingReturnPath);

export const clearCapturedMagicToken = () => {
  pendingMagicToken = null;
};

export const clearCapturedAgentLogin = () => {
  pendingMagicToken = null;
  pendingReturnPath = null;
};
